/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon24Solid = forwardRef('TechPowerButtonIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.5 2a1.5 1.5 0 0 0-3 0v9a1.5 1.5 0 0 0 3 0V2Z" }),
        React.createElement("path", { d: "M18.408 3.682a1.5 1.5 0 1 0-1.83 2.377 7.5 7.5 0 1 1-9.159.002 1.5 1.5 0 1 0-1.832-2.375 10.5 10.5 0 1 0 12.821-.004Z" })));
});
